import script from "./SeriesList.vue?vue&type=script&setup=true&lang=js"
export * from "./SeriesList.vue?vue&type=script&setup=true&lang=js"

import "./SeriesList.vue?vue&type=style&index=0&id=9d7f9318&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d7f9318"]])

export default __exports__